








import '@/assets/style/app.scss';
import { Component, Prop, Vue } from 'vue-property-decorator';
import { GPageBase } from '@/mixins';
import { ApiError } from '@/models/core/api-error';
import { setApiErrorHandler } from '@/service/api/api.service';
import { AxiosError } from 'axios';
import { GEnum } from '@/constants/enum.defination';
import { masterModule } from '@/store/modules/entities/master.module';

const CUSTOM_MESSAGE_ERROR_CODE: number[] = [-1, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 20, 22, 24, 84, 124, 135, 137, 150, 153, 154, 155, 156, 2001, 2002, 2003, 2004, 2005, 2006, 2007, 2009, 2012, 2013, 2015, 2021, 2022, 2023, 2029, 2030, 2033, 2034, 2035];
const EXCLUDE_MESSAGE_ERROR_CATEGORY: number[] = [];
const EXCLUDE_MESSAGE_ERROR_CODE: number[] = [2003]; //クラス全体の傾向はエラー時はダイアログ表示しない

@Component({
  name: 'app',
})
export default class App extends GPageBase {
  async mounted() {
    let showSessionError = async () => {
      this.$Modal.error({
        title: this.$t('INFO').toString(),
        content: this.$t('HTTP_ERROR.ERR_401').toString(),
        closable: false,
        okText: 'OK',
        onOk: () => {
          this.$router.push('/signin');
        },
        onCancel: () => {
          this.$router.push('/signin');
        },
      });
    };

    let showTimeOutError = () => {
      this.$Modal.error({
        title: 'エラー',
        content: 'タイムアウトが発生しました',
        closable: false,
        okText: 'OK',
        onOk: () => {},
      });
    };

    let showApiError = (err: ApiError) => {
      let msg: string;
      if (err && err.code !== 83) {
        if (CUSTOM_MESSAGE_ERROR_CODE.indexOf(err.code) !== -1) {
          switch (err.category) {
            case GEnum.ErrorCategory.None:
              msg = this.$t(`API_ERROR_MESSAGE_CODE.${err.code}`).toString();
              break;
            case GEnum.ErrorCategory.GrowApi:
              msg = this.$t(`GROW_API_ERROR_MESSAGE_CODE.${err.code}`).toString();
              break;
            case GEnum.ErrorCategory.AcademicApi:
              msg = this.$t(`ACADEMIC_ERROR_MESSAGE_CODE.${err.code}`).toString();
              break;
            case GEnum.ErrorCategory.AuthApi:
              msg = this.$t(`AUTH_ERROR_MESSAGE_CODE.${err.code}`).toString();
              break;
          }
        } else {
          msg = this.$t('GROW_API_COMMON_ERROR_MESSAGE').toString();
        }

        // Login 画面のエラーの場合はModal出さない
        if (EXCLUDE_MESSAGE_ERROR_CATEGORY.indexOf(err.category) !== -1 || EXCLUDE_MESSAGE_ERROR_CODE.indexOf(err.code) !== -1) {
          return;
        }
        this.$Notice.error({
          title: 'エラー',
          desc: msg,
        });
      }
      if (err && err.code === 83) {
        let msg83: any;
        let strRepVal: any = '';
        let strRep = err.reason.split('\n');
        strRep.forEach((value) => {
          strRepVal += `${value} <br />`;
        });
        msg83 = `${strRepVal} <br />`;

        this.$Notice.error({
          title: 'Error',
          desc: msg83,
          duration: 10,
        });
      }
    };

    let errorHandler = (e: AxiosError) => {
      if (e.code === 'ECONNABORTED') {
        showTimeOutError();
      }
      if (e.response && e.response.data) {
        if (e.response.status === 401) {
          this.$store.dispatch('invalidateAuthToken');
          showSessionError();
        } else {
          let err: ApiError = e.response.data;
          showApiError(err);
        }
      }
    };

    setApiErrorHandler(errorHandler);

    // 多言語対応 - 言語（ja, en）を取得
    await masterModule.fetchLanguages();
  }

  get template() {
    let tempName: string = 'GDefaultTemplate';
    switch (this.$route.meta.template) {
      case GEnum.Template.FullWidth:
        tempName = 'GFullWidthTemplate';
        break;
      default:
        tempName = 'GDefaultTemplate';
        break;
    }
    return () => import(`@/layout/${tempName}.vue`);
  }
}
